<template>
  <div id="app1">
    <div>
      <v-snackbar style="z-index: 2 !important;" transition="slide-x-reverse-transition" v-model="snackbar"
        timeout="800" :value="true" :color="snakclr" absolute outlined top right>
        <v-icon :color="snakclr">mdi-alert-outline</v-icon>
        {{ errMsg }}
        <v-icon @click="snackbar = false" class="float-right" :color="snakclr">mdi-close-circle</v-icon>

      </v-snackbar>
    </div>
    <!-- Mobile -->
    <div class="mblappbar d-md-none">
      <v-app-bar class="appbar elevation-1 px-4" absolute width="100%" permanent color="white">
        <v-row class="d-flex">
          <v-app-bar-nav-icon class="my-auto" color="#797E8A" @click.stop="drawer = !drawer">
          </v-app-bar-nav-icon>
          <v-col class="d-flex justify-center">
          </v-col>
          <v-menu open-on-hover down offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="my-auto" icon v-bind="attrs" v-on="on">
                <v-avatar size="40" color="#3B82F6">
                  <span class="white--text font-weight-bold title text-uppercase">{{
                    clientCode.slice(0, 1)
                  }}</span>
                </v-avatar>
              </v-btn>
            </template>
            <v-card @click="listval(vals = 'accs')" class="pa-2 rounded-lg elevation-0">
              <p class="lstctntit mb-0">{{ clientCode }}</p>
              <p>{{ clientEmail }}</p>

              <v-btn @click="handleLogout()" class="elevation-0" small text color="#3B82F6"
                style="background-color: aliceblue !important">
                <span class="font-weight-bold">Logout</span>
              </v-btn>
            </v-card>
          </v-menu>
        </v-row>
      </v-app-bar>
      <v-navigation-drawer color="#EFF6FF" class="pt-2" v-model="drawer" app>
        <template v-slot:prepend>
          <v-select :class="branchcodes.length > 1 ? 'd-block' : 'd-none'" color="#3B82F6" @change="branchFilter"
            outlined class="my-4 mx-2 rounded-lg" dense :items="branchcodes" label="Branchs" v-model="branchcode"
            hide-details></v-select>
        </template>
        <v-list nav link>

          <v-list-item-group v-model="sideOptionsDesktop" color="#3B82F6">
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'dash' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'dash')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.7334 12H20.0001" :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 4V8.26667" :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.27946 14.5557L6.15039 17.4559" :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M11.9999 15.7332C14.0618 15.7332 15.7333 14.0617 15.7333 11.9999C15.7333 9.93801 14.0618 8.26654 11.9999 8.26654C9.93807 8.26654 8.2666 9.93801 8.2666 11.9999C8.2666 14.0617 9.93807 15.7332 11.9999 15.7332Z"
                    :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'dash' ? '#ffffff' : '#000000'};`">Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'accsv' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'accsv')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.1111 4.88889H8.26667C6.77319 4.88889 6.02646 4.88889 5.45603 5.17954C4.95426 5.4352 4.54631 5.84315 4.29065 6.34491C4 6.91535 4 7.66208 4 9.15556V15.7333C4 17.2268 4 17.9735 4.29065 18.544C4.54631 19.0457 4.95426 19.4537 5.45603 19.7094C6.02646 20 6.77319 20 8.26667 20H14.8444C16.3379 20 17.0847 20 17.6551 19.7094C18.1569 19.4537 18.5648 19.0457 18.8205 18.544C19.1111 17.9735 19.1111 17.2268 19.1111 15.7333V12.8889M19.219 4.78105C20.2603 5.82245 20.2603 7.51089 19.219 8.55228C18.1776 9.59368 16.4891 9.59368 15.4477 8.55228C14.4063 7.51089 14.4063 5.82245 15.4477 4.78105C16.4891 3.73965 18.1776 3.73965 19.219 4.78105Z"
                    :stroke="activeitem == 'accsv' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'accsv' ? '#ffffff' : '#000000'};`">Accounts</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'clilst' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'clilst')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.3742 15.6872H9.67434C8.21677 15.6872 7.48799 15.6872 6.89497 15.8689C5.55977 16.278 4.51491 17.3334 4.10988 18.6821C3.92999 19.2811 3.92999 20.0172 3.92999 21.4895M16.9853 7.24739C16.9853 9.8693 14.8811 11.9948 12.2854 11.9948C9.6897 11.9948 7.58548 9.8693 7.58548 7.24739C7.58548 4.62548 9.6897 2.5 12.2854 2.5C14.8811 2.5 16.9853 4.62548 16.9853 7.24739Z"
                    :stroke="activeitem == 'clilst' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M9.62686 15.6977H14.3268C15.7843 15.6977 16.5131 15.6977 17.1061 15.8794C18.4413 16.2886 19.4862 17.344 19.8912 18.6927C20.0711 19.2917 20.0711 20.0277 20.0711 21.5"
                    :stroke="activeitem == 'clilst' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'clilst' ? '#ffffff' : '#000000'};`">Clients</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'per' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'per')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.44444 12.8889V16.4444M15.5556 11.1111V16.4444M12 7.55556V16.4444M8.26667 20H15.7333C17.2268 20 17.9735 20 18.544 19.7094C19.0457 19.4537 19.4537 19.0457 19.7094 18.544C20 17.9735 20 17.2268 20 15.7333V8.26667C20 6.77319 20 6.02646 19.7094 5.45603C19.4537 4.95426 19.0457 4.54631 18.544 4.29065C17.9735 4 17.2268 4 15.7333 4H8.26667C6.77319 4 6.02646 4 5.45603 4.29065C4.95426 4.54631 4.54631 4.95426 4.29065 5.45603C4 6.02646 4 6.77319 4 8.26667V15.7333C4 17.2268 4 17.9735 4.29065 18.544C4.54631 19.0457 4.95426 19.4537 5.45603 19.7094C6.02646 20 6.77319 20 8.26667 20Z"
                    :stroke="activeitem == 'per' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'per' ? '#ffffff' : '#000000'};`">Revenue</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="modeis != 'r'" class="rounded-lg"
              :style="`background-color:${activeitem == 'expe' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'expe')">
              <v-list-item-avatar tile size="22">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z"
                    :stroke="activeitem == 'expe' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'expe' ? '#ffffff' : '#000000'};`">Expenses</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'ince' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'ince')">
              <v-list-item-avatar tile size="22">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M19 10L5.00003 10M19 10L20.8642 13.1069C21.282 13.8032 21.4909 14.1514 21.5993 14.5262C21.6955 14.8582 21.7335 15.2045 21.7117 15.5495C21.6871 15.9389 21.5587 16.324 21.3019 17.0944L21.0941 17.7179C20.7007 18.8981 20.5039 19.4882 20.1391 19.9245C19.8169 20.3098 19.4032 20.608 18.9358 20.7918C18.4065 21 17.7845 21 16.5404 21L7.45967 21C6.2156 21 5.59356 21 5.06429 20.7918C4.5969 20.608 4.18315 20.3098 3.86096 19.9245C3.49611 19.4882 3.2994 18.8981 2.90599 17.7179L2.69816 17.0944C2.44137 16.324 2.31298 15.9389 2.28838 15.5495C2.26658 15.2044 2.30458 14.8582 2.40071 14.5261C2.5092 14.1514 2.71809 13.8032 3.13587 13.1069L5.00003 10M19 10L19.4173 8.53955C19.6151 7.84717 19.714 7.50097 19.6363 7.22708C19.5683 6.98715 19.413 6.78132 19.201 6.64996C18.959 6.5 18.599 6.5 17.8789 6.5L6.1212 6.5C5.4011 6.5 5.04105 6.5 4.79904 6.64996C4.58705 6.78132 4.43179 6.98715 4.36372 7.22708C4.28602 7.50097 4.38493 7.84717 4.58276 8.53955L5.00003 10M12 6.5H8.46431C7.94335 6.5 7.44373 6.28929 7.07535 5.91421C6.70698 5.53914 6.50003 5.03043 6.50003 4.5C6.50003 3.96957 6.70698 3.46086 7.07535 3.08579C7.44373 2.71071 7.94335 2.5 8.46431 2.5C11.2143 2.5 12 6.5 12 6.5ZM12 6.5H15.5357C16.0567 6.5 16.5563 6.28929 16.9247 5.91421C17.2931 5.53914 17.5 5.03043 17.5 4.5C17.5 3.96957 17.2931 3.46086 16.9247 3.08579C16.5563 2.71071 16.0567 2.5 15.5357 2.5C12.7857 2.5 12 6.5 12 6.5Z"
                    :stroke="activeitem == 'ince' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'ince' ? '#ffffff' : '#000000'};`">Incentive</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <!-- <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'mfr' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'mfr')">
              <v-list-item-avatar tile size="22">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.957 11.916C19.2352 11.916 21.082 10.0692 21.082 7.79102C21.082 5.51284 19.2352 3.66602 16.957 3.66602C14.6789 3.66602 12.832 5.51284 12.832 7.79102C12.832 10.0692 14.6789 11.916 16.957 11.916Z"
                    stroke="#666666" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M11.9167 13.75H5.5V20.1667H11.9167V13.75Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M1.83203 9.16667L5.4987 2.75L9.16536 9.16667H1.83203Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                </svg>

              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title :style="`color:${activeitem == 'mfr' ? '#ffffff' : '#000000'};`">Mutual
                  Fund</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item class="rounded-lg" @click="openMfNew()">
              <v-list-item-avatar tile size="22">
                  <!-- <img src="@/assets/Portfolio.svg" alt="Portfolio icon"> -->
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.957 11.916C19.2352 11.916 21.082 10.0692 21.082 7.79102C21.082 5.51284 19.2352 3.66602 16.957 3.66602C14.6789 3.66602 12.832 5.51284 12.832 7.79102C12.832 10.0692 14.6789 11.916 16.957 11.916Z"
                    stroke="#666666" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M11.9167 13.75H5.5V20.1667H11.9167V13.75Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M1.83203 9.16667L5.4987 2.75L9.16536 9.16667H1.83203Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Mutual Fund</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card style="cursor:pointer;" width="93%" class="ma-2 px-4 py-2 rounded-lg elevation-0 d-inline-flex">
              <v-row no-glutters>
                <v-col @click="newCopylink()" cols="10">
                  <span class="font-weight-bold subtitle-2">Referral link</span>
                </v-col>
                <v-col @click="copylink()" cols="2" class="text-right pt-4"> <v-tooltip open-delay="400" color="black"
                    bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_251_10223)">
                            <path
                              d="M3.33333 9.99992C2.71207 9.99992 2.40145 9.99992 2.15642 9.89842C1.82971 9.7631 1.57015 9.50353 1.43482 9.17683C1.33333 8.9318 1.33333 8.62117 1.33333 7.99992V3.46659C1.33333 2.71985 1.33333 2.34648 1.47865 2.06126C1.60648 1.81038 1.81046 1.60641 2.06134 1.47858C2.34656 1.33325 2.71992 1.33325 3.46666 1.33325H7.99999C8.62125 1.33325 8.93188 1.33325 9.17691 1.43475C9.50361 1.57007 9.76318 1.82964 9.8985 2.15634C9.99999 2.40137 9.99999 2.712 9.99999 3.33325M8.13333 14.6666H12.5333C13.2801 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3934 14.3935 14.1895 14.5213 13.9386C14.6667 13.6534 14.6667 13.28 14.6667 12.5333V8.13325C14.6667 7.38651 14.6667 7.01315 14.5213 6.72793C14.3935 6.47705 14.1895 6.27307 13.9386 6.14524C13.6534 5.99992 13.2801 5.99992 12.5333 5.99992H8.13333C7.38659 5.99992 7.01322 5.99992 6.72801 6.14524C6.47712 6.27307 6.27315 6.47705 6.14532 6.72793C5.99999 7.01315 5.99999 7.38651 5.99999 8.13325V12.5333C5.99999 13.28 5.99999 13.6534 6.14532 13.9386C6.27315 14.1895 6.47712 14.3934 6.72801 14.5213C7.01322 14.6666 7.38659 14.6666 8.13333 14.6666Z"
                              stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_251_10223">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span> </template>
                    <span>Copy your referral link</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card>
            <v-card style="cursor:pointer;" class="ma-2 px-4 py-2 rounded-lg elevation-0">
              <v-col class="pa-0" @click="apRedirect">
                <span class="font-weight-bold subtitle-2">AP/RA Links</span>
              </v-col>
            </v-card>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </div>

    <!-- Desktop -->
    <div class="dsknavdraw d-none d-md-block">
      <v-navigation-drawer color="#EFF6FF" class="pt-6 pl-2 v-navigation-drawer__border" app permanent>
        <template v-slot:prepend>
          <v-list-item class="mb-6">
            <img width="110px" src="@/assets/zebulogo.svg" alt="zebulogo" />
          </v-list-item>

          <v-select :class="branchcodes.length > 1 ? 'd-block' : 'd-none'" color="#3B82F6" @change="branchFilter"
            outlined class="mb-2 ml-2 mr-2 rounded-lg" dense :items="branchcodes" label="Branchs" v-model="branchcode"
            hide-details></v-select>
        </template>
        <v-list nav link color="#EFF6FF">
          <v-list-item-group v-model="sideOptionsDesktop" color="#3B82F6">
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'dash' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'dash')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.7334 12H20.0001" :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 4V8.26667" :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.27946 14.5557L6.15039 17.4559" :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M11.9999 15.7332C14.0618 15.7332 15.7333 14.0617 15.7333 11.9999C15.7333 9.93801 14.0618 8.26654 11.9999 8.26654C9.93807 8.26654 8.2666 9.93801 8.2666 11.9999C8.2666 14.0617 9.93807 15.7332 11.9999 15.7332Z"
                    :stroke="activeitem == 'dash' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'dash' ? '#ffffff' : '#000000'};`">Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'accsv' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'accsv')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.1111 4.88889H8.26667C6.77319 4.88889 6.02646 4.88889 5.45603 5.17954C4.95426 5.4352 4.54631 5.84315 4.29065 6.34491C4 6.91535 4 7.66208 4 9.15556V15.7333C4 17.2268 4 17.9735 4.29065 18.544C4.54631 19.0457 4.95426 19.4537 5.45603 19.7094C6.02646 20 6.77319 20 8.26667 20H14.8444C16.3379 20 17.0847 20 17.6551 19.7094C18.1569 19.4537 18.5648 19.0457 18.8205 18.544C19.1111 17.9735 19.1111 17.2268 19.1111 15.7333V12.8889M19.219 4.78105C20.2603 5.82245 20.2603 7.51089 19.219 8.55228C18.1776 9.59368 16.4891 9.59368 15.4477 8.55228C14.4063 7.51089 14.4063 5.82245 15.4477 4.78105C16.4891 3.73965 18.1776 3.73965 19.219 4.78105Z"
                    :stroke="activeitem == 'accsv' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'accsv' ? '#ffffff' : '#000000'};`">Accounts</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'clilst' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'clilst')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.3742 15.6872H9.67434C8.21677 15.6872 7.48799 15.6872 6.89497 15.8689C5.55977 16.278 4.51491 17.3334 4.10988 18.6821C3.92999 19.2811 3.92999 20.0172 3.92999 21.4895M16.9853 7.24739C16.9853 9.8693 14.8811 11.9948 12.2854 11.9948C9.6897 11.9948 7.58548 9.8693 7.58548 7.24739C7.58548 4.62548 9.6897 2.5 12.2854 2.5C14.8811 2.5 16.9853 4.62548 16.9853 7.24739Z"
                    :stroke="activeitem == 'clilst' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M9.62686 15.6977H14.3268C15.7843 15.6977 16.5131 15.6977 17.1061 15.8794C18.4413 16.2886 19.4862 17.344 19.8912 18.6927C20.0711 19.2917 20.0711 20.0277 20.0711 21.5"
                    :stroke="activeitem == 'clilst' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'clilst' ? '#ffffff' : '#000000'};`">Clients</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'per' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'per')">
              <v-list-item-avatar tile size="22">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.44444 12.8889V16.4444M15.5556 11.1111V16.4444M12 7.55556V16.4444M8.26667 20H15.7333C17.2268 20 17.9735 20 18.544 19.7094C19.0457 19.4537 19.4537 19.0457 19.7094 18.544C20 17.9735 20 17.2268 20 15.7333V8.26667C20 6.77319 20 6.02646 19.7094 5.45603C19.4537 4.95426 19.0457 4.54631 18.544 4.29065C17.9735 4 17.2268 4 15.7333 4H8.26667C6.77319 4 6.02646 4 5.45603 4.29065C4.95426 4.54631 4.54631 4.95426 4.29065 5.45603C4 6.02646 4 6.77319 4 8.26667V15.7333C4 17.2268 4 17.9735 4.29065 18.544C4.54631 19.0457 4.95426 19.4537 5.45603 19.7094C6.02646 20 6.77319 20 8.26667 20Z"
                    :stroke="activeitem == 'per' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'per' ? '#ffffff' : '#000000'};`">Revenue</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="modeis != 'r'" class="rounded-lg"
              :style="`background-color:${activeitem == 'expe' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'expe')">
              <v-list-item-avatar tile size="22">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z"
                    :stroke="activeitem == 'expe' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'expe' ? '#ffffff' : '#000000'};`">Expenses</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'ince' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'ince')">
              <v-list-item-avatar tile size="22">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M19 10L5.00003 10M19 10L20.8642 13.1069C21.282 13.8032 21.4909 14.1514 21.5993 14.5262C21.6955 14.8582 21.7335 15.2045 21.7117 15.5495C21.6871 15.9389 21.5587 16.324 21.3019 17.0944L21.0941 17.7179C20.7007 18.8981 20.5039 19.4882 20.1391 19.9245C19.8169 20.3098 19.4032 20.608 18.9358 20.7918C18.4065 21 17.7845 21 16.5404 21L7.45967 21C6.2156 21 5.59356 21 5.06429 20.7918C4.5969 20.608 4.18315 20.3098 3.86096 19.9245C3.49611 19.4882 3.2994 18.8981 2.90599 17.7179L2.69816 17.0944C2.44137 16.324 2.31298 15.9389 2.28838 15.5495C2.26658 15.2044 2.30458 14.8582 2.40071 14.5261C2.5092 14.1514 2.71809 13.8032 3.13587 13.1069L5.00003 10M19 10L19.4173 8.53955C19.6151 7.84717 19.714 7.50097 19.6363 7.22708C19.5683 6.98715 19.413 6.78132 19.201 6.64996C18.959 6.5 18.599 6.5 17.8789 6.5L6.1212 6.5C5.4011 6.5 5.04105 6.5 4.79904 6.64996C4.58705 6.78132 4.43179 6.98715 4.36372 7.22708C4.28602 7.50097 4.38493 7.84717 4.58276 8.53955L5.00003 10M12 6.5H8.46431C7.94335 6.5 7.44373 6.28929 7.07535 5.91421C6.70698 5.53914 6.50003 5.03043 6.50003 4.5C6.50003 3.96957 6.70698 3.46086 7.07535 3.08579C7.44373 2.71071 7.94335 2.5 8.46431 2.5C11.2143 2.5 12 6.5 12 6.5ZM12 6.5H15.5357C16.0567 6.5 16.5563 6.28929 16.9247 5.91421C17.2931 5.53914 17.5 5.03043 17.5 4.5C17.5 3.96957 17.2931 3.46086 16.9247 3.08579C16.5563 2.71071 16.0567 2.5 15.5357 2.5C12.7857 2.5 12 6.5 12 6.5Z"
                    :stroke="activeitem == 'ince' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'ince' ? '#ffffff' : '#000000'};`">Incentive</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <!-- <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'mfr' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'mfr')">
              <v-list-item-avatar tile size="22">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.957 11.916C19.2352 11.916 21.082 10.0692 21.082 7.79102C21.082 5.51284 19.2352 3.66602 16.957 3.66602C14.6789 3.66602 12.832 5.51284 12.832 7.79102C12.832 10.0692 14.6789 11.916 16.957 11.916Z"
                    stroke="#666666" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M11.9167 13.75H5.5V20.1667H11.9167V13.75Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M1.83203 9.16667L5.4987 2.75L9.16536 9.16667H1.83203Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                </svg>

              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title :style="`color:${activeitem == 'mfr' ? '#ffffff' : '#000000'};`">Mutual
                  Fund</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item class="rounded-lg" @click="openMfNew()">
              <v-list-item-avatar tile size="22">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.957 11.916C19.2352 11.916 21.082 10.0692 21.082 7.79102C21.082 5.51284 19.2352 3.66602 16.957 3.66602C14.6789 3.66602 12.832 5.51284 12.832 7.79102C12.832 10.0692 14.6789 11.916 16.957 11.916Z"
                    stroke="#666666" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M11.9167 13.75H5.5V20.1667H11.9167V13.75Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                  <path d="M1.83203 9.16667L5.4987 2.75L9.16536 9.16667H1.83203Z" stroke="#666666" stroke-width="1.4"
                    stroke-miterlimit="10" stroke-linecap="square" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Mutual Fund</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

                <v-list-item  class="rounded-lg"
              :style="`background-color:${activeitem == 'close' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'close')">
              <v-list-item-avatar tile size="22">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z"
                    :stroke="activeitem == 'close' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'close' ? '#ffffff' : '#000000'};`">Closer Request</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="rounded-lg"
              :style="`background-color:${activeitem == 'rekyc' ? '#3B82F6' : 'transparent'}!important;`"
              @click="listval(vals = 'rekyc')">
              <v-list-item-avatar tile size="22">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12L11 14L15 10M20.6179 5.98434C20.4132 5.99472 20.2072 5.99997 20 5.99997C16.9265 5.99997 14.123 4.84453 11.9999 2.94434C9.87691 4.84446 7.07339 5.99985 4 5.99985C3.79277 5.99985 3.58678 5.9946 3.38213 5.98423C3.1327 6.94783 3 7.95842 3 9.00001C3 14.5915 6.82432 19.2898 12 20.622C17.1757 19.2898 21 14.5915 21 9.00001C21 7.95847 20.8673 6.94791 20.6179 5.98434Z"
                    :stroke="activeitem == 'rekyc' ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :style="`color:${activeitem == 'rekyc' ? '#ffffff' : '#000000'};`">REKYC Request</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-item-group>
        </v-list>
        <v-card v-click-outside="onClickOutside" style="cursor:pointer;" width="93%"
          class="py-2 rounded-lg elevation-0 d-inline-flex" :class="copyis == false ? 'ma-2 mb-0 pr-1' : 'ma-2 px-4'"
          :color="copyis == false ? 'transparent' : '#ffffff'">
          <v-row v-if="copyis" no-glutters>
            <v-col @click="newCopylink()" cols="9">
              <span class="font-weight-bold subtitle-2">Referral link</span>
            </v-col>
            <v-col @click="copylink()" cols="1" class="text-right pt-4"> <v-tooltip open-delay="400" color="black"
                bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_251_10223)">
                        <path
                          d="M3.33333 9.99992C2.71207 9.99992 2.40145 9.99992 2.15642 9.89842C1.82971 9.7631 1.57015 9.50353 1.43482 9.17683C1.33333 8.9318 1.33333 8.62117 1.33333 7.99992V3.46659C1.33333 2.71985 1.33333 2.34648 1.47865 2.06126C1.60648 1.81038 1.81046 1.60641 2.06134 1.47858C2.34656 1.33325 2.71992 1.33325 3.46666 1.33325H7.99999C8.62125 1.33325 8.93188 1.33325 9.17691 1.43475C9.50361 1.57007 9.76318 1.82964 9.8985 2.15634C9.99999 2.40137 9.99999 2.712 9.99999 3.33325M8.13333 14.6666H12.5333C13.2801 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3934 14.3935 14.1895 14.5213 13.9386C14.6667 13.6534 14.6667 13.28 14.6667 12.5333V8.13325C14.6667 7.38651 14.6667 7.01315 14.5213 6.72793C14.3935 6.47705 14.1895 6.27307 13.9386 6.14524C13.6534 5.99992 13.2801 5.99992 12.5333 5.99992H8.13333C7.38659 5.99992 7.01322 5.99992 6.72801 6.14524C6.47712 6.27307 6.27315 6.47705 6.14532 6.72793C5.99999 7.01315 5.99999 7.38651 5.99999 8.13325V12.5333C5.99999 13.28 5.99999 13.6534 6.14532 13.9386C6.27315 14.1895 6.47712 14.3934 6.72801 14.5213C7.01322 14.6666 7.38659 14.6666 8.13333 14.6666Z"
                          stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_251_10223">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span> </template>
                <span>Copy your referral link</span>
              </v-tooltip>
            </v-col>
            <v-col @click="editlink()" cols="1" class="text-right pt-4">
              <v-tooltip open-delay="400" color="black" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_251_10737)">
                        <path
                          d="M5.66665 10.3333L10.3333 5.66663M5.99998 2.66665V1.33331M9.99998 13.3333V14.6666M2.66665 5.99998H1.33331M13.3333 9.99998H14.6666M3.27612 3.27612L2.33331 2.33331M12.7239 12.7238L13.6667 13.6666M8 11.7712L6.58579 13.1854C5.54439 14.2268 3.85595 14.2268 2.81455 13.1854C1.77315 12.144 1.77315 10.4555 2.81455 9.41413L4.22877 7.99992M11.7712 7.99992L13.1855 6.58571C14.2268 5.54431 14.2268 3.85587 13.1855 2.81447C12.1441 1.77307 10.4556 1.77307 9.41422 2.81447L8 4.22868"
                          stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_251_10737">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </template>
                <span>Create a referral link, to easy share</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <div v-else class="d-inline-flex">
            <v-tooltip open-delay="400" color="black" bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon @click="copyis = true" class="mt-2" size="28" color="#000000">mdi-chevron-left</v-icon>
                </span>
              </template>
              <span>Copy your referral link</span>
            </v-tooltip>
            <v-text-field solo flat hide-details dense v-model="refcode" class="rounded-lg caption" type="text"
              label="referral code" oninput="this.value = this.value.toUpperCase()">
              <template #append>
                <div v-if="refcode.length > 0" @click="refcode.length > 0 ? editLinkGen() : ''">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_251_10223)">
                      <path
                        d="M3.33333 9.99992C2.71207 9.99992 2.40145 9.99992 2.15642 9.89842C1.82971 9.7631 1.57015 9.50353 1.43482 9.17683C1.33333 8.9318 1.33333 8.62117 1.33333 7.99992V3.46659C1.33333 2.71985 1.33333 2.34648 1.47865 2.06126C1.60648 1.81038 1.81046 1.60641 2.06134 1.47858C2.34656 1.33325 2.71992 1.33325 3.46666 1.33325H7.99999C8.62125 1.33325 8.93188 1.33325 9.17691 1.43475C9.50361 1.57007 9.76318 1.82964 9.8985 2.15634C9.99999 2.40137 9.99999 2.712 9.99999 3.33325M8.13333 14.6666H12.5333C13.2801 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3934 14.3935 14.1895 14.5213 13.9386C14.6667 13.6534 14.6667 13.28 14.6667 12.5333V8.13325C14.6667 7.38651 14.6667 7.01315 14.5213 6.72793C14.3935 6.47705 14.1895 6.27307 13.9386 6.14524C13.6534 5.99992 13.2801 5.99992 12.5333 5.99992H8.13333C7.38659 5.99992 7.01322 5.99992 6.72801 6.14524C6.47712 6.27307 6.27315 6.47705 6.14532 6.72793C5.99999 7.01315 5.99999 7.38651 5.99999 8.13325V12.5333C5.99999 13.28 5.99999 13.6534 6.14532 13.9386C6.27315 14.1895 6.47712 14.3934 6.72801 14.5213C7.01322 14.6666 7.38659 14.6666 8.13333 14.6666Z"
                        :stroke="refcode.length > 0 ? '#000000' : 'grey'" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_251_10223">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </template>
            </v-text-field>
          </div>
        </v-card>
        <v-card style="cursor:pointer;" class="ma-2 px-4 py-2 rounded-lg elevation-0">
          <v-col class="pa-0" @click="apRedirect">
            <span class="font-weight-bold subtitle-2">AP/RA Links</span>
          </v-col>
        </v-card>
        <template v-slot:append>
          <v-divider></v-divider>
          <div>
            <v-list-item two-line @click="listval(vals = 'accs')">
              <v-list-item-avatar>
                <v-avatar color="#3B82F6">
                  <span class="white--text font-weight-bold title text-uppercase mr-2">{{
                    clientCode.slice(0, 1)
                  }}</span>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="lstctntit">{{ clientCode }}</v-list-item-title>
                <v-list-item-subtitle>{{ clientEmail }}</v-list-item-subtitle>
              </v-list-item-content>
              <button id="logout-button" @click="handleLogout()">
                <v-icon size="24" color="#3B82F6">mdi-logout </v-icon>
              </button>
            </v-list-item>
          </div>
        </template>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { apiurl } from "../apiUrl";

export default {
  data() {
    return {
      errMsg: '',
      snackbar: false,
      snakclr: 'default',

      permode: null,
      clientCode: "",
      clientEmail: '',
      emailId: '',
      sideOptionsDesktop: 0,
      activeitem: 'dash',
      sideOptionsMobile: '',
      drawer: false,
      branchcodes: [],
      branchcode: null,

      copyis: true,
      refcode: '',
      modeis: null
    };
  },
  created() {
    let modeis = localStorage.getItem('mode');
    if (modeis == 'RM') {
      this.modeis = 'r'
    } else {
      this.modeis = 'b'
    }

    let branchcode = localStorage.getItem('brcode');
    if (branchcode != null && branchcode) {
      // this.getAllClientData();
    } else {
      this.$router.push("/");
    }
  },
  mounted() {
    this.clientCode = localStorage.getItem("brcode");

    this.clientEmail = localStorage.getItem("email")
    this.session = localStorage.getItem("session")
    let valsto = localStorage.getItem("activeitem")
    if ((valsto == 'dash') || (valsto == 'clilst') || (valsto == 'per') || (valsto == 'stat') || (valsto == 'accs') || (valsto == 'accsv') || (valsto == 'cliacc') || (valsto == 'expe') || (valsto == 'ince') || (valsto == 'incst') || (valsto == 'close') || (valsto == 'rekyc')) {
      this.activeitem = valsto;
    } else {
      this.activeitem = 'dash';
    }
    if (this.clientCode && this.session) {
      this.emailId = localStorage.getItem("email")
    } else {
      this.$router.push("/")
    }
    if (this.activeitem == 'dash') {
      this.$router.push("/dashboard");
      this.sideOptionsDesktop = 0;
    }
    else if (this.activeitem == 'accsv') {
      this.$router.push("/accounts");
      this.sideOptionsDesktop = 1;
    }
    else if (this.activeitem == 'clilst') {
      this.$router.push("/clients");
      this.sideOptionsDesktop = 2;
    }
    else if (this.activeitem == 'per') {
      this.$router.push("/revenue");
      this.sideOptionsDesktop = 3;
    }
    else if (this.activeitem == 'expe') {
      this.$router.push("/expensive");
      this.sideOptionsDesktop = 4;
    }
    else if (this.activeitem == 'ince') {
      this.$router.push("/incentive");
      this.sideOptionsDesktop = 5;
    }
    else if (this.activeitem == 'accs') {
      this.$router.push("/user");
      this.sideOptionsDesktop = 6;
    }
      else if (this.activeitem == 'close') {
      this.$router.push("/closer");
      this.sideOptionsDesktop = 7;
    }
      else if (this.activeitem == 'rekyc') {
      this.$router.push("/rekyc");
      this.sideOptionsDesktop = 8;
    }

    this.getBranch();
    // else if (this.activeitem == 'incst') {
    //   this.$router.push("/incstat");
    //   this.sideOptionsDesktop = 5;
    // }
  },

  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    onClickOutside() {
      if (this.copyis == false) {
        this.copyis = true;
      }
    },
    handleLogout() {
      localStorage.clear();
      this.$router.push("/");
    },
    editlink() {
      this.copyis = false;
    },
    editLinkGen() {
      navigator.clipboard.writeText(`https://oa.mynt.in/?ref=${this.refcode}`);
      this.errMsg = 'Link as copied ';
      this.snackbar = true;
      this.snakclr = 'success';
    },
    apRedirect() {
      window.open(
        `https://ap.zebull.in/share-gen`,
        "_blank"
      );
    },
    openMfNew() {
      window.open(`https://zebumf-admin.web.app/`, "_blank");
    },
    newCopylink() {
      window.open(
        `https://oa.mynt.in/?ref=${this.branchcode}`,
        "_blank"
      );
    },
    copylink() {
      navigator.clipboard.writeText(`https://oa.mynt.in/?ref=${this.branchcode}`);
      this.errMsg = 'Link as copied ';
      this.snackbar = true;
      this.snakclr = 'success';
    },
    listval(vals) {
      if (vals != this.activeitem) {
        this.activeitem = vals;
        if (this.activeitem == 'dash') {
          this.$router.push("/dashboard")
          this.sideOptionsDesktop = 0;
        }
        else if (this.activeitem == 'accsv') {
          this.$router.push("/accounts");
          this.sideOptionsDesktop = 1;
        }
        else if (this.activeitem == 'clilst') {
          this.$router.push("/clients")
          this.sideOptionsDesktop = 2;
        }
        else if (this.activeitem == 'per') {
          this.$router.push("/revenue")
          this.sideOptionsDesktop = 3;
        }
        else if (this.activeitem == 'expe') {
          this.$router.push("/expensive");
          this.sideOptionsDesktop = 4;
        } else if (this.activeitem == 'ince') {
          this.$router.push("/incentive");
          this.sideOptionsDesktop = 5;
        }
        else if (this.activeitem == 'accs') {
          this.$router.push("/user")
          this.sideOptionsDesktop = 6;
        }
        else if (this.activeitem == 'mfr') {
          this.$router.push("/mfpage");
          this.sideOptionsDesktop = 7;
        }
        else if (this.activeitem == 'allorder') {
          this.$router.push("/allorder");
          this.sideOptionsDesktop = 8;
        }
        else if (this.activeitem == 'dailyorders') {
          this.$router.push("/dailyorders");
          this.sideOptionsDesktop = 9;
        }
        else if (this.activeitem == 'mandatedetails') {
          this.$router.push("/mandatedetails");
          this.sideOptionsDesktop = 10;
        }
        else if (this.activeitem == 'redemptionrequest') {
          this.$router.push("/redemptionrequest");
          this.sideOptionsDesktop = 10;
        }
        else if (this.activeitem == 'sip') {
          this.$router.push("/sip");
          this.sideOptionsDesktop = 10;
        }
        else if (this.activeitem == 'holdings') {
          this.$router.push("/holdings");
          this.sideOptionsDesktop = 10;
        }
         else if (this.activeitem == 'nfo') {
          this.$router.push("/nfo");
          this.sideOptionsDesktop = 10;
        }
         else if (this.activeitem == 'mfbook') {
          this.$router.push("/mfobook");
          this.sideOptionsDesktop = 10;
        }
         else if (this.activeitem == 'close') {
          this.$router.push("/closer");
          this.sideOptionsDesktop = 10;
        }
         else if (this.activeitem == 'rekyc') {
          this.$router.push("/rekyc");
          this.sideOptionsDesktop = 11;
        }
        localStorage.setItem('activeitem', vals)
      }
    },
    getBranch() {
      let data = JSON.stringify({
        "email": this.clientEmail
      });

      let config = {
        method: 'post',
        url: `${apiurl}/submaster_email_list`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          let branchcode = localStorage.getItem("brcode")
          if (response.data.msg != "email doesn't exists") {
            axiosThis.branchcodes = response.data[0].client_id;
            if (branchcode) {
              axiosThis.branchcode = branchcode;
            } else {
              axiosThis.branchcode = axiosThis.branchcodes[0];
            }
            // console.log("ye");
          } else {
            axiosThis.branchcode = branchcode
            axiosThis.branchcodes = [];
            // console.log("no");
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
    branchFilter() {
      localStorage.setItem("brcode", this.branchcode)
      setTimeout(() => {
        window.location.reload();
      }, 400);
    }
  },
};
</script>

<style>
.lstctntit {
  font-weight: 700 !important;
}

.ctnbtl {
  font-weight: 500 !important;
}

.trmnucolsl {
  background-color: #f9fbfc !important;
  background-size: 80% !important;
}

.v-slide-group__prev.v-slide-group__prev--disabled {
  display: none !important;
}

.v-list--nav .v-list-item:not(:last-child):not(:only-child),
.v-list--rounded .v-list-item:not(:last-child):not(:only-child) {
  margin-bottom: 4px !important;
}

.v-data-table .v-data-table__wrapper table thead th {
  z-index: 0 !important;
  background-color: #EFF6FF !important;
  color: #000000 !important;
  border-color: #EFF6FF !important;
}

.v-navigation-drawer__content::-webkit-scrollbar {
  width: 5px;
}

.v-navigation-drawer__content::-webkit-scrollbar-track {
  border-radius: 10px;
}

.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 10px;
}

.v-main {
  padding-left: 256px !important;
}

::-webkit-scrollbar {
  width: 6px !important;
}

::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.6) !important;
  border-radius: 16px !important;
}

.v-list-item--link:before {
  color: #3B82F6 !important;
}

@media only screen and (max-width: 959px) {
  .appbar {
    position: fixed !important;
    z-index: 1 !important;
  }

  .v-main {
    padding-left: 0px !important;
  }

  .v-menu__content {
    box-shadow: 0px 8px 16px -4px rgba(22, 34, 51, 0.08) !important;
  }
}
</style>

<style scoped>
.v-navigation-drawer>>>.v-navigation-drawer__border {
  display: none;
}
</style>